<div class="text-center grid gap-4 max-w-2xl">
    <div class="mb-5 text-5xl font-bold">
      {{ 'paymentSplit:orderSummary' | translate }}
    </div>
    <div class="">
      {{ 'paymentSplit:orderSummarySubtitle' | translate }}
    </div>

    <div class="flex">
        <div class="basis-2/3 flex flex-col flex-wrap content-start">
            <div class="text-xl font-medium">
                {{'paymentSplit:studentPaying' | translate}}
            </div>
            <div class="flex flex-wrap content-start">
                <p>
                    <span class="text-sm text-gray-400">{{'currencyCard:currentBalance' | translate}}: </span>
                    <span class="text-sm text-blue-500">{{ currencyAccount?.balance | currency}}</span>
                </p>
            </div>
        </div>
        <div class="basis-1/3 flex flex-col flex-wrap content-end text-2xl font-medium">
            {{budget | currency}} {{currency}}
        </div>
    </div>

    <mat-divider></mat-divider>

    <div>
        <div *ngFor="let split of splits, index as i" class="flex mb-2">
            <div class="basis-2/3  flex flex-col flex-wrap content-start">
                <div class="text-xl font-medium">
                    #{{i+1}} {{split.bankAccount.alias}}
                </div>
                <div class="flex flex-wrap content-start">
                    <p class="text-sm text-gray-400">{{'transactions:reference' | translate}}: {{split.reference}}</p>
                </div>
            </div>
            <div class="basis-1/3 flex flex-col flex-wrap content-end">
                {{split.amount | currency}} {{currency}}
            </div>
        </div>
    </div>


    <div class="flex bg-blue-50 p-7 rounded">
        <div class="basis-2/3 flex flex-col flex-wrap content-start">
            <div class="flex flex-wrap content-start">
                <p class="text-xl font-medium">{{'paymentSplit:comission' | translate}}</p>
            </div>
            <div class="flex flex-wrap content-start">
                <p class="text-sm text-gray-400">{{'paymentSplit:comissionDescription' | translate}}</p>
            </div>
        </div>
        <div class="basis-1/3 flex flex-col flex-wrap content-end">
            <p class="text-2xl font-medium text-blue-500">{{comission | currency}} {{currency}}</p>
        </div>
    </div>
</div>